import {ModuleEnum} from 'src/api/ProactApiClient';
import {VendorCustomOperations} from './customOperations';
import {useModulePermissions} from './useModulePermissions';

/**
 * Hook for Vendor module permissions.
 * Includes standard operations plus Vendor-specific custom operations.
 */
export function useVendorPermissions() {
  return useModulePermissions(ModuleEnum.Vendors, VendorCustomOperations);
}
